<template>
    <div class="autocomplete">
        <v-autocomplete
            v-model="result"
            :items="items"
            :loading="isLoading"
            :search-input.sync="search"
            :rules="rules"
            color="white"
            item-text="registrationNumber"
            item-value="id"
            label="Start typing to search"
            placeholder="Start typing to search"
            outline
            single-line
            deletable-chips
            return-object
            clearable
            :disabled="disabled || !hasAllRoles(['VehicleView'])"
            :class="{ 'small-field': smallField }"
        ></v-autocomplete>

        <div class="add-more" v-if="hasAllRoles(['VehicleAdd']) && !disableAdd && isDirty && this.items.length === 0">
            <i class="material-icons" @click="showDialog = true">add</i>
        </div>

        <v-dialog
            v-model="showDialog"
            v-if="hasAllRoles(['VehicleAdd']) && !disableAdd && fleet && fleet.id"
            max-width="850"
        >
            <v-card>
                <v-card-title class="headline">Create vehicle</v-card-title>
                <v-card-text>
                    <vehicle-create-from @success="showDialog = false" @close-dialog="showDialog = false" :fleet-uuid="fleet.id" is-popup></vehicle-create-from>
                </v-card-text>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import VehicleApi from '@/api/VehicleApi'
import VehicleCreateFrom from './VehicleCreateFrom'

const vehicleApi = new VehicleApi()

export default {
    name: 'VehicleAutocomplete',
    data () {
        return {
            isLoading: false,
            items: [],
            entries: [],
            search: null,
            isDirty: false,
            showDialog: false,
            form: {},
            handler: ''
        }
    },
    components: {
        VehicleCreateFrom
    },
    props: {
        value: {
            type: [Object, null]
        },
        selected: {
            type: [Object, null]
        },
        rules: {
            type: Array,
            default: () => []
        },
        disabled: {
            type: Boolean,
            required: false,
            default: false
        },
        fleet: {
            type: Object,
            required: false,
            default: () => {}
        },
        isPopup: {
            type: Boolean,
            required: false,
            default: false
        },
        disableAdd: {
            type: Boolean,
            required: false,
            default: false
        },
        smallField: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    watch: {
        search: {
            handler: function (value, oldVal) {
                this.getVehicles(value)
                this.isDirty = true
            },
            deep: true
        },

        fleet: {
            handler: function (value, oldVal) {
                this.getVehicles(this.search)
                this.isDirty = true
            },
            deep: true
        }
    },
    computed: {
        result: {
            get () {
                if (null != this.value && this.items.indexOf(this.value)) {
                    // eslint-disable-next-line vue/no-side-effects-in-computed-properties
                    this.items.push(this.value)
                }
                return this.value
            },
            set (val) {
                this.$emit('input', val)
            }
        }
    },
    mounted () {
        this.getVehicles()
    },

    methods: {
        async getVehicles (value) {
            if (!this.hasAllRoles(['VehicleView'])) return
            const response = await vehicleApi.getVehicles({
                skip: 0,
                take: 10,
                fleetId: this.fleet ? this.fleet.id : null,
                registrationNumber: value
            })
            this.items = response.payload.items
        }
    }
}
</script>

<style scoped lang="scss">
//.autocomplete {
//    position: relative;
//
//    .add-more {
//        position: absolute;
//        cursor: pointer;
//        right: -28px;
//        top: 13px;
//    }
//}
</style>
